import * as joint from '@clientio/rappid';

import { FlowchartConfig } from '../../base/flowchart.config';

export const getHeightOfSubComponent = (subElement: joint.dia.Element) => {
  const hasTags = subElement?.getEmbeddedCells()?.find((embed) => embed.attributes.isElementTag);
  const description = subElement?.getEmbeddedCells()?.find((embed) => embed.attributes.isElementDescription == true);
  let height = subElement.attributes.size.height;

  if (!hasTags && !description) {
    height = FlowchartConfig.containerNode.subComponentNode.size.height;
  }

  if (hasTags) {
    height = FlowchartConfig.containerNode.subComponentNode.size.heightTags;
  }
  if (description) {
    const descriptionEmbed = subElement?.getEmbeddedCells()?.find((embed) => embed.attributes.isElementDescription == true);
    height = descriptionEmbed.get('attrs').foreignObject.height;

    if (hasTags) {
      height += FlowchartConfig.containerNode.subComponentNode.size.heightTags;
    } else {
      height += FlowchartConfig.containerNode.subComponentNode.size.height;
    }
  }
  return height;
};
